import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M10 6l-6 8h12l-6-8z", clipRule: "evenodd" }));
export default SvgArrowUp;
